import { takeLeading } from "redux-saga/effects";

import { fetchRewardsAccountsSaga } from "./fetchRewardsAccountsSaga";
import { fetchRewardsAccounts } from "../../reducers/user";

export function* watchFetchRewardsAccounts() {
  yield takeLeading(fetchRewardsAccounts, fetchRewardsAccountsSaga);
}
